import styled from 'styled-components';
import Tab from '@mui/material/Tab';
import {
	MAX_MD,
	MD_LG_BUTTON_2,
	MD_LG_PAGE_DIVIDER_1,
} from '@silverrailtech/srtlibrary';
import colors, {
	baseContainerFillSecondary,
	baseContainerFillStrong,
	interactionStrokePrimary1,
	interactionStrokeSubtle,
	textPrimary1,
	textPrimary3,
	white,
} from '../colors';

export const PageTitle = styled.h1`
	${MD_LG_PAGE_DIVIDER_1}
	color: ${interactionStrokePrimary1};
	margin: 16px 0 8px;
`;

export const OuiGoTab = styled(Tab)`
	&& {
		${MD_LG_BUTTON_2}
		text-transform: none;
	}
`;

export const TabBar = styled.div`
	align-items: center;
	background-color: ${baseContainerFillStrong};
	display: flex;
	justify-content: space-between;
	margin-left: -15px;
	margin-right: -15px;
	padding: 8px 16px;

	@media screen and (max-width: ${MAX_MD}) {
		align-items: stretch;
		flex-direction: column;
		gap: 12px;
	}
`;

export default {
	page: {
		backgroundColor: colors.backgroundColor,
		minHeight: 'calc(100vh - 72px)',
		paddingBottom: 24,
	},
	tabs: {
		minHeight: 32,
	},
	tab: {
		backgroundColor: baseContainerFillSecondary,
		border: `1px solid ${interactionStrokeSubtle}`,
		borderRadius: 16,
		color: textPrimary3,
		marginRight: 4,
		minHeight: 32,
		padding: '6px 16px',
	},
	activeTab: {
		backgroundColor: white,
		border: `1px solid ${interactionStrokePrimary1}`,
		color: textPrimary1,
	},
	panel: {
		marginLeft: -15,
		marginRight: -15,
	},
};
